import type { IBaseControlSetting } from '~/presentation/reports/common/type';

import { EControlType } from '~/presentation/reports/common/type';
import { SelectCompoundContent } from './SelectCompoundContent';
import { SelectBase } from '../../SelectBase';
import { cls } from '~/utils';

export interface IControlSelectCompound extends IBaseControlSetting {
  type: EControlType.SELECT_COMPOUND;
}

export const SelectCompound: React.FC<IControlSelectCompound> = (props) => {
  const { label, configs, disabled, info, dependentControls } = props;

  if (!configs?.length) return null;

  return (
    <SelectBase
      label={label}
      textVariant="bodySm"
      disabled={disabled}
      id={props.id}
      type={EControlType.SELECT_BASE}
      info={info}
      dependentControls={dependentControls}
    >
      <div className={cls('flex gap-[6px] [&>*]:min-w-0')}>
        <SelectCompoundContent {...props} />
      </div>
    </SelectBase>
  );
};
